
import { func } from '../../main';
import axios from '../../api'
import router from '../../router';

const state = {
    WorkTimerList: [],
    Loading: false,
    WorkTimerNoMoreData: false,

};


const getters = {
    GetWorkTimerList(state: any) {
        return state.WorkTimerList;
    },
    GetWorkTimerNoMoreData(state: any) {
        return state.WorkTimerNoMoreData;
    },
};

const mutations = {
    SetWorkTimerNoMoreData(state: any, val: any) {
        state.WorkTimerNoMoreData = val;
    },
    SetWorkTimerList(state: any, list: any) {
        state.WorkTimerList = list;
    },
    AddWorkTimerList(state: any, list: any) {
        state.WorkTimerList = state.WorkTimerList.concat(list);
    }
};

const actions = {

    WorkTimerAddOrEdit(context: any, item: any) {
        context.commit("SetLoading", true);

        axios.post('WorkTimer/WorkTimerAddOrEdit', item).then((response: any) => {
            context.commit("SetLoading", false);
            if (response.data.isSuccess) {
                func.showSuccessMessage(response.data.message);
                setTimeout(function () { router.push('/WorkTimerList'); }, 1500);
            } else {
                func.showErrorMessage(response.data.message);
            }

        }, error => {
            func.showErrorMessage("خطا در ارسال اطلاعات");
            context.commit("SetLoading", false);
            console.log(error);
        });
    },
    CreateWorkTimerFolderAtt(context: any, item: any) {
        context.commit("SetLoading", true);

        axios.post('WorkTimer/CreateAtt', item).then((response: any) => {
            context.commit("SetLoading", false);
            if (response.data.isSuccess) {
                func.showSuccessMessage(response.data.message);
            } else {
                func.showErrorMessage(response.data.message);
            }

        }, error => {
            func.showErrorMessage("خطا در ارسال اطلاعات");
            context.commit("SetLoading", false);
            console.log(error);
        });
    },
    WorkTimerFolderEdit(context: any, item: any) {
        context.commit("SetLoading", true);

        axios.post('WorkTimer/UpdateFolder', item).then((response: any) => {
            context.commit("SetLoading", false);
            if (response.data.isSuccess) {
                func.showSuccessMessage(response.data.message);
            } else {
                func.showErrorMessage(response.data.message);
            }

        }, error => {
            func.showErrorMessage("خطا در ارسال اطلاعات");
            context.commit("SetLoading", false);
            console.log(error);
        });
    },
    GetWorkTimerListFromServer(context: any, Filter: any) {
        context.commit("SetLoading", true);
        axios.get("WorkTimer/GetList", {
            params: {
                userId: Filter.userId,
                text: Filter.text,
                date: Filter.date,
                status: Filter.status,
                page: Filter.page,
                projectId: Filter.projectId,
            }
        })
            .then(data => {
                context.commit("SetLoading", false);
                if (data.data.length < 1) {
                    context.commit("SetWorkTimerNoMoreData", true);
                    context.commit("SetWorkTimerList", data.data);
                    return;
                }

                if (Filter.page == 1) {
                    context.commit("SetWorkTimerNoMoreData", false);
                    context.commit("SetWorkTimerList", data.data);
                }
                else {
                    context.commit("SetWorkTimerNoMoreData", false);
                    context.commit("AddWorkTimerList", data.data);
                }
            });
    },

};

export default {
    state,
    getters,
    mutations,
    actions
};
